export const xAPI_PATH = {
    /* 홈(HOM) */
    "/today/middleStudyToday": {
        gnb: "HOM",
    },
    // 신규 홈 - 기존 middleStudyToday 대체 예정
    "/today/allNewStudyToday": {
        gnb: "HOM",
    },

    /* SMART내신(SMT) */
    // 전체
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=ALL": {
        gnb: "SMT",
        lnbNm1: "전체강좌",
        lnbCd1: "SMTAL",
    },
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=NASIN": {
        gnb: "SMT",
        lnbNm1: "내신진도",
        lnbCd1: "SMT00",
    },
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=VACA": {
        gnb: "SMT",
        lnbNm1: "방학특강",
        lnbCd1: "SMT01",
    },
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=EXAM": {
        gnb: "SMT",
        lnbNm1: "시험특강",
        lnbCd1: "SMT02",
    },
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=PREMID": {
        gnb: "SMT",
        lnbNm1: "예비중",
        lnbCd1: "SMT03",
    },
    "/smart/middleStudySmart?UP_MENU_CD=SMART&MENU_CD=PREHIGH": {
        gnb: "SMT",
        lnbNm1: "고등과정",
        lnbCd1: "SMT04",
    },

    /* 대치TOP(TOP) */
    // 전체 강좌
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=ALL": {
        gnb: "TOP",
        lnbNm1: "전체강좌",
        lnbCd1: "TOPAL",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=DEEPTHINK": {
        gnb: "TOP",
        lnbNm1: "깊은생각",
        lnbCd1: "TOP00",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=FUTRSRCH": {
        gnb: "TOP",
        lnbNm1: "미래탐구(과학)",
        lnbCd1: "TOP01",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=FUTRSRCHK": {
        gnb: "TOP",
        lnbNm1: "미래탐구(국어)",
        lnbCd1: "TOP02",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=ILE": {
        gnb: "TOP",
        lnbNm1: "ILE",
        lnbCd1: "TOP03",
    },
    "/top/middleStudyTop?MENU_CD=APROACDY&UP_MENU_CD=DTOP": {
        gnb: "TOP",
        lnbNm1: "에이프로아카데미",
        lnbCd1: "TOP04",
    },
    "/top/middleStudyTop?MENU_CD=HAMMATH&UP_MENU_CD=DTOP": {
        gnb: "TOP",
        lnbNm1: "함수학학원",
        lnbCd1: "TOP05",
    },
    "/top/middleStudyTop?MENU_CD=HAMEN&UP_MENU_CD=DTOP": {
        gnb: "TOP",
        lnbNm1: "함영원영어학원",
        lnbCd1: "TOP06",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=WRACDY": {
        gnb: "TOP",
        lnbNm1: "세계로학원",
        lnbCd1: "TOP07",
    },
    "/top/middleStudyTop?UP_MENU_CD=DTOP&MENU_CD=CNA": {
        gnb: "TOP",
        lnbNm1: "C&A논술학원",
        lnbCd1: "TOP08",
    },

    /* 영어전문관(ENG) */
    // 전체 강좌
    "/specialClass/specialClassMain?UP_MENU_CD=ENGMP&MENU_CD=ALL": {
        gnb: "ENG",
        lnbNm1: "전체강좌",
        lnbCd1: "ENGAL",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=ENGMP&MENU_CD=GRAMMAR": {
        gnb: "ENG",
        lnbNm1: "문법",
        lnbCd1: "ENG00",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=ENGMP&MENU_CD=READ": {
        gnb: "ENG",
        lnbNm1: "독해",
        lnbCd1: "ENG01",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=ENGMP&MENU_CD=LISTEN": {
        gnb: "ENG",
        lnbNm1: "듣기",
        lnbCd1: "ENG02",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=ENGMP&MENU_CD=VOCA": {
        gnb: "ENG",
        lnbNm1: "어휘",
        lnbCd1: "ENG03",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=ENGMP&MENU_CD=WRITE": {
        gnb: "ENG",
        lnbNm1: "쓰기/영작",
        lnbCd1: "ENG04",
    },

    /* 수학전문관(MAT) */
    // 전체 강좌
    "/specialClass/specialClassMain?UP_MENU_CD=MATHP&MENU_CD=ALL": {
        gnb: "MAT",
        lnbNm1: "전체강좌",
        lnbCd1: "MATAL",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=MATHP&MENU_CD=LVL": {
        gnb: "MAT",
        lnbNm1: "수준별",
        lnbCd1: "MAT00",
    },
    "/specialClass/specialClassSub?UP_MENU_CD=MATHP&MENU_CD=SCTN": {
        gnb: "MAT",
        lnbNm1: "영역별",
        lnbCd1: "MAT01",
    },

    /* 자격증&인증(LCN) */
    // 전체
    "/licenseClass/licenseClassMain?UP_MENU_CD=LCNSE&MENU_CD=ALL&FROM_CD=TOTL": {
        gnb: "LCN",
        lnbNm1: "전체",
        lnbCd1: "LCNAL",
    },
    "/licenseClass/licenseClassSub?UP_MENU_CD=LCNSE&MENU_CD=CHNA": {
        gnb: "LCN",
        lnbNm1: "중국어",
        lnbCd1: "LCN00",
    },
    "/licenseClass/licenseClassSub?UP_MENU_CD=LCNSE&MENU_CD=JPAN": {
        gnb: "LCN",
        lnbNm1: "일본어",
        lnbCd1: "LCN01",
    },
    "/licenseClass/licenseClassSub?UP_MENU_CD=LCNSE&MENU_CD=KHIST": {
        gnb: "LCN",
        lnbNm1: "한국사능력검정",
        lnbCd1: "LCN02",
    },
    "/licenseClass/licenseClassSub?UP_MENU_CD=LCNSE&MENU_CD=CHSE": {
        gnb: "LCN",
        lnbNm1: "한자능력검정",
        lnbCd1: "LCN03",
    },

    /* 나의 학습방(MYS) */
    "/mystudy/studyPlan": {
        gnb: "MYS",
        lnbNm1: "나의 계획학습",
        lnbCd1: "MYS00",
    },
    "/mystudy/studyClas?pageType=REGISTER": {
        gnb: "MYS",
        lnbNm1: "계획학습 등록",
        lnbCd1: "MYS0001",
    },
    "/mystudy/studyClas?pageType=UPDATE&PEDC_GR_CD=NORMAL": {
        gnb: "MYS",
        lnbNm1: "계획학습 변경",
        lnbCd1: "MYS0002",
    },
    "/mystudy/studyState": {
        gnb: "MYS",
        lnbNm1: "나의 학습현황",
        lnbCd1: "MYS01",
    },
    "com.wjthinkbig.nfmiddle.client.activity.view.fragment.StudyNote": {
        gnb: "MYS",
        lnbNm1: "나의 학습노트",
        lnbCd1: "MYS02",
    },
    "/mystudy/studyAllTab": {
        gnb: "MYS",
        lnbNm1: "올탭 과외 학습",
        lnbCd1: "MYS03",
    },

    /* AI학습관(AIS) */
    // 전체 강좌
    "/aime?UP_MENU_CD=AISTUDY&MENU_CD=ALL": {
        gnb: "AIS",
        lnbNm1: "전체",
        lnbCd1: "AIAL",
    },
    "/aime?UP_MENU_CD=AISTUDY&MENU_CD=MATH": {
        gnb: "AIS",
        lnbNm1: "AI수학",
        lnbCd1: "AIS00",
    },
    "/aime?UP_MENU_CD=AISTUDY&MENU_CD=ENGM": {
        gnb: "AIS",
        lnbNm1: "AI영어",
        lnbCd1: "AIS01",
    },

    /* TEST라운지(TST) */
    // E-TEST
    "/testzone?UP_MENU_CD=TESTL&MENU_CD=ETST": {
        gnb: "TST",
        lnbNm1: "ETEST",
        lnbCd1: "TST00",
    },
    "/testzone?UP_MENU_CD=TESTL&MENU_CD=TRTST": {
        gnb: "TST",
        lnbNm1: "영수모의고사",
        lnbCd1: "TST01",
    },
    "/testzone?UP_MENU_CD=ETST&MENU_CD=TRTST": {
        gnb: "TST",
        lnbNm1: "영수모의고사",
        lnbCd1: "TST01",
    },
    "/testzone?UP_MENU_CD=TESTL&MENU_CD=ELTST": {
        gnb: "TST",
        lnbNm1: "영어듣기 능력평가",
        lnbCd1: "TST02",
    },
    "/testzone?UP_MENU_CD=ETST&MENU_CD=ELTST": {
        gnb: "TST",
        lnbNm1: "영어듣기 능력평가",
        lnbCd1: "TST02",
    },
    "/testzone?UP_MENU_CD=ETST&MENU_CD=SVTST": {
        gnb: "TST",
        lnbNm1: "학력평가 기출문제",
        lnbCd1: "TST03",
    },
    "/testzone?UP_MENU_CD=TESTL&MENU_CD=HUTST": {
        gnb: "TST",
        lnbNm1: "학업성취도평가 대비",
        lnbCd1: "TST04",
    },
    "/WrongAnswerNotes": {
        gnb: "TST",
        lnbNm1: "오답노트",
        lnbCd1: "TST05",
    },
    "/testzone?UP_MENU_CD=TESTL&MENU_CD=RSBPT": {
        gnb: "TST",
        lnbNm1: "올백TEST",
        lnbCd1: "TST06",
    },

    /* 영어라운지(ELG) */
    "/englishLibrary": {
        gnb: "ELG",
        lnbNm1: "English Library",
        lnbCd1: "ELG00",
    },
    "/englishVoca/index": {
        gnb: "ELG",
        lnbNm1: "VOCA 트레이닝",
        lnbCd1: "ELG01",
    },
    "/englishVoca/schedule": {
        gnb: "ELG",
        lnbNm1: "중학 필수 어휘",
        lnbCd1: "ELG0100",
    },
    // 중학 기초 / 고등 핵심 어휘는 IA 에 하위 코드가 없어 VOCA 트레이닝 기준으로 둔다.
    "/englishVoca/basicVoca": {
        gnb: "ELG",
        lnbNm1: "VOCA 트레이닝",
        lnbCd1: "ELG01",
    },
    "/englishVoca/highSchoolVoca": {
        gnb: "ELG",
        lnbNm1: "VOCA 트레이닝",
        lnbCd1: "ELG01",
    },

    /* 학습서비스(시험대비 라운지)(SVC) */
    // 시험대비 바로답변
    "/liveQna": {
        gnb: "SVC",
        lnbNm1: "시험대비 바로답변",
        lnbCd1: "SVC00",
    },
    "/allZip": {
        gnb: "SVC",
        lnbNm1: "교과서 ALL-ZIP",
        lnbCd1: "SVC01",
    },
    "/referenceRoom": {
        gnb: "SVC",
        lnbNm1: "학습자료실",
        lnbCd1: "SVC02",
    },
    "/studyMusic": {
        gnb: "SVC",
        lnbNm1: "열공뮤직",
        lnbCd1: "SVC03",
    },
    "/performExam/performExamMain": {
        gnb: "SVC",
        lnbNm1: "수행평가 가이드",
        lnbCd1: "SVC04",
    },
    "/literatureLibrary": {
        gnb: "SVC",
        lnbNm1: "문학도서관",
        lnbCd1: "SVC05",
    },

    /* 진로진학(CRE) */
    "/schoolCourse/schoolCourseMain?PLTF_TY=ALTT&PLTF_CD=STDLRNI": {
        gnb: "CRE",
        lnbNm1: "서울대 선배의 학습법",
        lnbCd1: "CRE00",
    },
    "/schoolCourse/schoolCourseMain?PLTF_TY=ALTT&PLTF_CD=DPMINTC": {
        gnb: "CRE",
        lnbNm1: "학과소개",
        lnbCd1: "CRE01",
    },
    "/schoolCourse/schoolCourseMain?PLTF_TY=ALTT&PLTF_CD=OCPTITV": {
        gnb: "CRE",
        lnbNm1: "직업인 인터뷰",
        lnbCd1: "CRE02",
    },
    "/schoolCourse/schoolCourseMain?PLTF_TY=ALTT&PLTF_CD=STDGIDE": {
        gnb: "CRE",
        lnbNm1: "과목별 학습가이드",
        lnbCd1: "CRE03",
    },

    /* 같이라운지(LOG) */
    "/reward": {
        gnb: "LOG",
        lnbNm1: "성적 우수 장학생",
        lnbCd1: "LOG00",
    },

    /* 스타샵(STR) */
    "/starshop?tab=1": {
        gnb: "STR",
        lnbNm1: "나의 별 현황",
        lnbCd1: "STR00",
    },
    "/starshop?tab=2": {
        gnb: "STR",
        lnbNm1: "나의 목표",
        lnbCd1: "STR01",
    },
    "/starshop?tab=3": {
        gnb: "STR",
        lnbNm1: "무엇을 바꿔볼까?",
        lnbCd1: "STR02",
    },

    /* 마이페이지(MYP) */
    "/mypage": {
        gnb: "MYP",
        lnbNm1: "찜한 강좌",
        lnbCd1: "MYP00",
    },
    "/mypage?viewType=tab3": {
        gnb: "MYP",
        lnbNm1: "나의 강좌 Q&A",
        lnbCd1: "MYP01",
    },
    "/mypage?viewType=tab1": {
        gnb: "MYP",
        lnbNm1: "찜한 강좌",
        lnbCd1: "MYP00",
    },
    "/mypage/myNoti": {
        gnb: "MYP",
        lnbNm1: "알림",
        lnbCd1: "MYP02",
    },
    "/mypage/myNote": {
        gnb: "MYP",
        lnbNm1: "1:1톡",
        lnbCd1: "MYP03",
    },
    "/mypage/myInfo": {
        gnb: "MYP",
        lnbNm1: "개인정보 수정",
        lnbCd1: "MYP04",
    },
    "/mypage/myExamInfo": {
        gnb: "MYP",
        lnbNm1: "시험정보",
        lnbCd1: "MYP0403",
    },

    /* 고객센터(CUS) */
    "/csboard?tab=anounList": {
        gnb: "CUS",
        lnbNm1: "공지사항",
        lnbCd1: "CUS00",
    },
    "/csboard?tab=faqList": {
        gnb: "CUS",
        lnbNm1: "자주 묻는 질문",
        lnbCd1: "CUS01",
    },
    "/csboard?tab=termsInfo": {
        gnb: "CUS",
        lnbNm1: "약관보기",
        lnbCd1: "CUS02",
    },

    /* 설정(FAV) */
    "com.wjthinkbig.nfmiddle.client.activity.view.fragment.SettingFragment": {
        gnb: "SET",
    },
};

export const xAPI_ID_VALUE = {
    serviceUnit: {
        btn_menu_0000: "btn_menu_0000",
        btn_menu_0001: "btn_menu_0001",
        btn_menu_0002: "btn_menu_0002",
        btn_menu_0003: "btn_menu_0003",
        btn_class_0000: "btn_class_0000",
        btn_class_0001: "btn_class_0001",
        btn_class_0002: "btn_class_0002",
        btn_search_0000: "btn_search_0000",
        btn_search_0001: "btn_search_0001",
        btn_search_0002: "btn_search_0002",
        btn_search_0003: "btn_search_0003",
        btn_search_0004: "btn_search_0004",
        btn_banner_0001: "btn_banner_0001",
        btn_clas_0000: "btn_clas_0000",
        btn_aimath_0000: "btn_aimath_0000",
        btn_aimath_0002: "btn_aimath_0002",
        btn_aimath_0003: "btn_aimath_0003",
        btn_aimath_0004: "btn_aimath_0004",
        btn_aimath_0005: "btn_aimath_0005",
        btn_aimath_0006: "btn_aimath_0006",
        btn_aimath_0007: "btn_aimath_0007",
        btn_aieng_0000: "btn_aieng_0000",
        btn_aieng_0001: "btn_aieng_0001",
        btn_aieng_0002: "btn_aieng_0002",
        btn_aieng_0003: "btn_aieng_0003",
        btn_aieng_0004: "btn_aieng_0004",
        btn_aieng_0005: "btn_aieng_0005",
        btn_schedule_0000: "btn_schedule_0000",
        btn_schedule_0001: "btn_schedule_0001",
        btn_schedule_0002: "btn_schedule_0002",
        btn_schedule_0003: "btn_schedule_0003",
        btn_schedule_0004: "btn_schedule_0004",
        btn_schedule_0005: "btn_schedule_0005",
        btn_schedule_0006: "btn_schedule_0006",
        btn_schedule_0007: "btn_schedule_0007",
        btn_schedule_0008: "btn_schedule_0008",
        btn_schedule_0009: "btn_schedule_0009",
        btn_test_0000: "btn_test_0000",
        btn_test_0001: "btn_test_0001",
        btn_test_0002: "btn_test_0002",
        btn_test_0003: "btn_test_0003",
        btn_test_0004: "btn_test_0004",
        btn_test_0005: "btn_test_0005",
        btn_test_0006: "btn_test_0006",
        btn_test_0007: "btn_test_0007",
        btn_allzip_0001: "btn_allzip_0001",
        btn_reference_preview: "btn_reference_preview",
        btn_reference_download: "btn_reference_download",
        btn_engvoca_0001: "btn_engvoca_0001",
        btn_question_0000: "btn_question_0000",
        btn_aieng_0006: "btn_aieng_0006",
        btn_aieng_0007: "btn_aieng_0007",
        btn_chatbot_0000: "btn_chatbot_0000", // 챗봇 열기(선택)
        btn_chatbot_0001: "btn_chatbot_0001", // 챗봇 닫기
        btn_chatbot_0002: "btn_chatbot_0002", // 챗봇 메시지 버튼 선택(메뉴추천/콘텐츠추천)
        // 시험특강 (시험기간 중 추천 강좌 노출)
        btn_smt_0001: "btn_smt_0001", // 전체 강좌 보기 선택
        btn_smt_0002: "btn_smt_0002", // 추천 강좌 보기 선택
        // 시험대비모드
        btn_epm_0000: "btn_epm_0000", // 플로팅 버튼 선택
        btn_epm_0001: "btn_epm_0001", // 오늘의 학습 카드 GO
        btn_epm_0002: "btn_epm_0002", // 시험특강 GO
        btn_epm_0003: "btn_epm_0003", // 단원마스터 GO
        btn_epm_0004: "btn_epm_0004", // AI 독서실 GO
        btn_epm_0005: "btn_epm_0005", // AI영어 문법 공략 GO
        btn_epm_0006: "btn_epm_0006", // AI수학 약점 공략 GO
        btn_epm_0007: "btn_epm_0007", // 교과서 All-Zip GO
        btn_epm_0008: "btn_epm_0008", // 실시간 바로 답변 GO
        btn_epm_0009: "btn_epm_0009", // 시험 성적 등록 GO
        btn_epm_0010: "btn_epm_0010", // 상단 고정 설정
        btn_epm_0011: "btn_epm_0011", // 미션 안내 탭
        btn_epm_0012: "btn_epm_0012", // 성적 관리 탭
        btn_epm_0013: "btn_epm_0013", // 장학생 후기 탭
        btn_epm_0014: "btn_epm_0014", // 성적 우수 장학생 GO
        btn_epm_0015: "btn_epm_0015", // 성적 입력/수정하기
        btn_epm_0016: "btn_epm_0016", // 미션 현황 탭

        // 시험대비모드 인트로 팝업
        btn_epmintro_0000: "btn_epmintro_0000", // 시험 기간을 몰라요
        btn_epmintro_0001: "btn_epmintro_0001", // 시험대비모드 시작
        btn_epmintro_0002: "btn_epmintro_0002", // 이번에는 시험을 보지 않아요
        btn_epmintro_0003: "btn_epmintro_0003", // 팝업 닫기
        btn_epmintro_0004: "btn_epmintro_0004", // 이번에는 시험을 보지 않아요 확인
        btn_exinfo_0000: "btn_exinfo_0000", // 시험 일정 저장
        btn_exinfo_0001: "btn_exinfo_0001", // 시험성적 저장
    },
    serviceMessage: {
        pop_epmintro_0000: "pop_epmintro_0000", // 시험대비모드 인트로 팝업 노출
        pop_mtip_0000: "pop_mtip_0000", // 홈 : 이번주 완료율 기준 확인 안내 팝업
        pop_mtip_0001: "pop_mtip_0001", // 홈 : 학습 강의수 기준 확인 안내 팝업
        pop_mtip_0002: "pop_mtip_0002", // 홈 : 올탭 과외/숙제 팝업
        btn_chatbot_0000: "btn_chatbot_0000", // 챗봇 열기(선택)
        btn_chatbot_0001: "btn_chatbot_0001", // 챗봇 닫기
        btn_chatbot_0002: "btn_chatbot_0002", // 챗봇 메시지 버튼 선택(메뉴추천/콘텐츠추천)
    },
    screen: {
        scr_login_0000: "scr_login_0000",
        scr_0000_0000: "scr_0000_0000",
        scr_search_0000: "scr_search_0000",
        scr_search_0001: "scr_search_0001",
        scr_search_0002: "scr_search_0002",
        scr_search_0003: "scr_search_0003",
        scr_search_0004: "scr_search_0004",
        scr_sroom_0000: "scr_sroom_0000",
        scr_clas_0000: "scr_clas_0000",
        scr_clas_0001: "scr_clas_0001", // 삭제됨
        scr_clas_0002: "scr_clas_0002",
        scr_clas_0003: "scr_clas_0003",
        scr_smart_detail: "scr_smart_detail",
        scr_dtop_detail: "scr_dtop_detail",
        scr_aimath_0000: "scr_aimath_0000",
        scr_aimath_0001: "scr_aimath_0001",
        scr_aimath_0002: "scr_aimath_0002",
        scr_aieng_0000: "scr_aieng_0000",
        scr_aieng_0001: "scr_aieng_0001",
        scr_aieng_0002: "scr_aieng_0002",
        scr_aieng_0003: "scr_aieng_0003",
        scr_aieng_0004: "scr_aieng_0004",
        scr_aieng_0005: "scr_aieng_0005",
        scr_eng_0001: "scr_eng_0001",
        scr_math_0001: "scr_math_0001",
        scr_schedule_0000: "scr_schedule_0000",
        scr_schedule_0001: "scr_schedule_0001",
        scr_schedule_0002: "scr_schedule_0002",
        scr_schedule_0003: "scr_schedule_0003",
        scr_schedule_0004: "scr_schedule_0004",
        scr_schedule_0005: "scr_schedule_0005",
        scr_schedule_0006: "scr_schedule_0006",
        scr_schedule_0007: "scr_schedule_0007",
        scr_schedule_0008: "scr_schedule_0008",
        scr_mystatus_0000: "scr_mystatus_0000",
        scr_mystatus_0001: "scr_mystatus_0001",
        scr_mystatus_0002: "scr_mystatus_0002",
        scr_test_0000: "scr_test_0000",
        scr_test_0001: "scr_test_0001",
        scr_test_0002: "scr_test_0002",
        scr_test_0003: "scr_test_0003",
        scr_test_0004: "scr_test_0004",
        scr_test_0005: "scr_test_0005",
        scr_test_0006: "scr_test_0006",
        scr_test_0007: "scr_test_0007",
        scr_allzip_0001: "scr_allzip_0001",
        scr_reference_preview: "scr_reference_preview",
        scr_reference_download: "scr_reference_download",
        scr_engvoca_0000: "scr_engvoca_0000",
        scr_engvoca_0001: "scr_engvoca_0001",
        scr_engvoca_0002: "scr_engvoca_0002",
        scr_engvoca_0003: "scr_engvoca_0003",
        scr_quicka_0000: "scr_quicka_0000",
        scr_mypage_0000: "scr_mypage_0000",
        scr_mypage_0001: "scr_mypage_0001",
        scr_mypage_0002: "scr_mypage_0002",
        scr_mypage_0003: "scr_mypage_0003",
        scr_mypage_schoolfind: "scr_mypage_schoolfind",
        scr_mypage_bookset: "scr_mypage_bookset",
        scr_classchange_0000: "scr_classchange_0000",
        scr_classchange_0001: "scr_classchange_0001",
        scr_timetable_0000: "scr_timetable_0000",
        scr_qna_0000: "scr_qna_0000",
    },
    viewPort: {
        are_0000_0000: "are_0000_0000",
        are_0000_0001: "are_0000_0001",
        are_0000_0002: "are_0000_0002",
        are_0000_0003: "are_0000_0003",
        are_0000_0004: "are_0000_0004",
    },
    assessment: {
        NA: "NA",
    },
    question: {
        NA: "NA",
    },
    explanation: {
        NA: "NA",
    },
    video: {
        NA: "NA",
    },
};

export const XAPI_CODE = {
    ID_NAME_CODES: {
        SCREEN_CODE: "screenCode", // 화면 진입
        BUTTON_CODE: "buttonCode", // 버튼/메뉴 선택
        AREA_CODE: "areaCode", // 영역 진입
        SERVICE_MESSAGE_CODE: "svc_msg_cd", // 서비스 메시지 코드
    },
    ACTIVITIES: {
        SERVICE_UNIT: "serviceUnit", // 서비스 객체
        SERVICE_MESSAGE: "serviceMessage", // 서비스 메시지
        SCREEN: "screen", // 화면
        VIEWPORT: "viewPort", // 노출영역
        LEARNING_CONTENT: "learningContent", // 학습보고서
        ASSESSMENT: "assessment", // 평가
        QUESTION: "question", // 문항콘텐츠
        EXPLANATION: "explanation", // 해설
        VIDEO: "video", // 영상콘텐츠
    },
    VERBS: {
        ANSWERED: "answered", // 제출했다
        ATTEMPTED: "attempted", // 시도했다
        COMPLETED: "completed", // 완료했다
        CONNECTED: "connected", // 연결되었다
        DELETED: "deleted", // 삭제했다
        DISCONNECTED: "disconnected", // 연결이 해제되었다
        FOCUSED: "focused", // 활성화되었다
        INITIALIZED: "initialized", // 시작했다
        INTERACTED: "interacted", // 상호작용을 시도했다
        MARKED: "marked", // 표기했다
        OPENED: "opened", // 진입했다
        PAUSED: "paused", // 일시중지했다
        PLAYED: "played", // 재생을 시작했다
        SEEKED: "seeked", // 이동했다
        SELECTED: "selected", // 선택했다
        SHOWED: "showed", // 보여졌다
        TERMINATED: "terminated", // 이탈했다, 종료했다
        UNFOCUSED: "unfocused", // 비활성화되었다
        JOINED: "joined", // 가입했다
        LEFT: "left", // 탈퇴했다
        SIGNIN: "signIn", // 로그인했다
        SIGNOUT: "signOut", // 로그아웃했다
        SWITCHED: "switched", // 변경했다
    },
};

export const xAPI_KEY = {
    /* 경로 관련 */
    gnb: "gnb", // gnb
    lnbNm1: "lnbNm1", // 이름
    lnbCd1: "lnbCd1", // 코드

    /* 타입 관련 */
    playerType: "playerType", // 플레이어타입 (ex. APPLY(응시), RE_APPLY(재응시))
    studyType: "studyType", // 학습타입
    btnType: "btnType", // 학습시작/응시하기 상태값 >>> btnStatus 어떨까요???  >>> btnType으로 하겠습니다 ㅎㅎ!! 굿
    cornerType: "cornerType", // 코너타입
    conceptType: "conceptType", // 학습 종류 (ex. CONCEPT(개념학습), VOC(VOC단어학습))
    videoType: "videoType", // 영상 종류 (ex. NL(일반강의), EL(해설영상))

    /* 코드 관련 */
    testCode: "testCode", // 테스트코드
    classCode: "classCode", // 강좌코드(=clasSeq)
    teacherCode: "teacherCode", // 강사코드
    lectureCode: "lectureCode", // 강의코드(=lecSeq)
    courseCode: "courseCode", // 과목코드
    cornerCode: "cornerCode", // 코너코드

    smstCd: "smstCd", // 학기코드
    examCd: "examCd", // 시험지코드
    qstCd: "qstCd", // 문항코드(=QST_CD)
    qstUnitCd: "qstUnitCd", // 단원코드(=QST_UNIT_SEQ)

    /* 문항 관련 */
    qstTy: "qstTy", // 문항유형 (ex. QST_A, QST_B)
    qstCnt: "qstCnt", // 총 문항수

    /* 메뉴 관련 */
    menuName: "menuName", // 메뉴명
    menuCode: "menuCode", // 메뉴코드

    /* 선택된 관련 */
    selectedDay: "selectedDay", // 선택된 요일들
    selectedDate: "selectedDate", // 선택된 날짜
    selectedSchool: "selectedSchool", // 선택된 학교
    selectedGrade: "selectedGrade", // 선택된 학년
    selectedBook: "selectedBook", // 선택된 교과서
    selectedUnit: "selectedUnit", // 선택된 단원
    selectedSubjectCode: "selectedSubject", // 선택된 과목코드
    selectedCourseCode: "selectedCourse", // 선택된 강좌코드

    /* 일련번호 관련 */
    ablityExamSeq: "ablityExamSeq", // 시험평가 일련번호(=ABLITY_EXAM_SEQ)
    aiRcmnMstrSeq: "aiRcmnMstrSeq", // 영어시험 일련번호(=AI_RCMN_MSTR_SEQ)
    aiCornerMappingSeq: "aiCornerMappingSeq", // 코너매핑 일련번호(=AI_CONER_MPNG_SEQ)
    allZipSeq: "allZipSeq", // ALL-ZIP 일련번호
    referenceSeq: "referenceSeq", // 학습자료실 일련번호

    /* Video 관련 */
    speedAsis: "speedAsis", // 기존 재생 속도
    speedTobe: "speedTobe", // 변경 재생 속도
    playTime: "playerTime", // 영상 재생 시간
    seekType: "seekType", // 재생 시점 이동 방법 (ex. BTN(버튼), BAR(재생바))
    pauseDurationTime: "pauseDuration", // 일시정지 상태 지속 시간

    displayFrom: "displayFrom", // 기존 화질
    displayTo: "displayTo", // 변경 화질
    autoSet: "autoSet", // Auto 적용 여부

    /* 기타 관련 */
    subject: "subject", // 과목
    publisher: "publisher", // 출판사
    year: "year", // 연도
    mm: "mm", // 월
    times: "times", // 회차
    grade: "grade", // 응시학년
    category: "category", // 카테고리
    bookTitle: "bookTitle", // 교재/교과서명
    keyword: "keyword", // 검색어
    previewDownloadClickCnt: "previewDownload", // 미리보기/다운로드 클릭 수
    reEntry: "reEntry", // 재진입 여부 (ex. Y, N)
    status: "status", // 찜하기 상태 (ex. Y, N)
    nrstStdDtm: "nrstStdDtm", // 최초 응시 일시
    compCnt: "compCnt", // 학습 완료 횟수
    question: "question", // Q&A 질문 내용

    /* 챗봇 관련 (category 는 상단 '기타 관련'의 category 키 재사용) */
    clas_seq: "clas_seq", // 챗봇 강좌코드
    lec_seq: "lec_seq", // 챗봇 강의코드
    coner_ctts_seq: "coner_ctts_seq", // 챗봇 코너 컨텐츠 일련 번호
    coner_seq: "coner_seq", // 챗봇 코너 일련번호
};
